const ITEMS = [
    "Awareness over blame",
    "The pattern, not the partner",
    "5-minute daily reflections",
    "Spot your energy leaks",
    "Break the silent distance",
    "Made for busy women",
];

export const Marquee = () => (
    <div
        className="relative overflow-hidden border-y border-plum/10 bg-blush/70 py-4"
        data-testid="editorial-marquee"
    >
        <div className="marquee-track flex w-max items-center">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    aria-hidden={i >= ITEMS.length}
                    className="flex items-center gap-10 pr-10 font-serif text-[0.78rem] uppercase tracking-[0.3em] text-plum/70 sm:text-sm"
                >
                    {item}
                    <span className="text-gold">&#10022;</span>
                </span>
            ))}
        </div>
    </div>
);

export default Marquee;
